// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UnlockTwoToneSvg from "@ant-design/icons-svg/es/asn/UnlockTwoTone";
import AntdIcon from '../components/AntdIcon';

var UnlockTwoTone = function UnlockTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UnlockTwoToneSvg
  }));
};

UnlockTwoTone.displayName = 'UnlockTwoTone';
export default React.forwardRef(UnlockTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/UnlockTwoTone.js
// module id = 1981
// module chunks = 0